/**
 * Builds Client Gallery ranks for one publish session.
 *
 * Contract:
 * - `orderedPhotoIds` is a snapshot of the current Photo Editor display order. For a selected
 *   subset, it contains only those photos while preserving their relative display order.
 * - A new session assigns contiguous ranks after the server-provided `photoMaxRank`, so an empty
 *   gallery starts at rank 1 and later uploads are appended to the bottom.
 * - Only an immediate in-memory retry provides `previouslyAssignedRanks`. Reusing that map keeps
 *   ranks stable across parallel completion, batching, and immediate retries.
 * - A retry from a later session does not provide previous ranks and is appended like a new upload.
 */
export function getPublishPhotoRanks(
	orderedPhotoIds: string[],
	photoMaxRank: number,
	previouslyAssignedRanks?: ReadonlyMap<string, number>,
) {
	return (
		previouslyAssignedRanks ??
		new Map(orderedPhotoIds.map((photoId, index) => [photoId, photoMaxRank + index + 1]))
	)
}
